export function validateDomain(email, domains) {
    const domain = email.split("@")[1].toLowerCase();
	return domains?.includes(domain)
}
